import {useLiveEventQuery} from './useLiveEventQuery';

export const useCurrentLiveEventId = () => {
    const {
        query: {data: liveEventData},
    } = useLiveEventQuery();

    return liveEventData?.id || -1;
};
